import { Select } from 'antd';
import React, { useMemo } from 'react';
import { Pagination } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import css from './GlobalPagination.less';

const { Option } = Select;

interface IProps {
  current: number;
  total: number;
  pageSize: number;
  pageOnChange: (page: number, pageSize: number) => void;
  pageSizeChange: (value) => void;
  paginationProps;
  pageSizeOption?: number[];
  pageSizeWidth?: number;
  setCurrent?: () => void;
  totalText?: string;
}
const GlobalPagination = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    current,
    total,
    pageOnChange,
    pageSizeChange,
    pageSize,
    pageSizeOption = [20, 60, 100],
    paginationProps,
    totalText,
    pageSizeWidth = 120,
  } = props;
  const startTotal = useMemo(
    () => (current - 1) * pageSize + 1,
    [current, pageSize],
  );

  const allTotal = useMemo(
    () => (pageSize * current > total ? total : pageSize * current),
    [current, pageSize, total],
  );

  return (
    <div className={css.globalPagination}>
      <Pagination
        onChange={pageOnChange}
        pageSize={pageSize}
        current={current}
        total={total}
        showQuickJumper={!!paginationProps.showQuickJumper}
      />
      <div>
        <span className={css.paginationTotal}>
          {totalText
            ? `${totalText} ${replaceI18nVariables(
                getI18n('general.globalPagination.of'),
                startTotal,
                allTotal,
                total,
              )}`
            : `${replaceI18nVariables(
                getI18n('general.globalPagination.displayingproducts'),
                startTotal,
                allTotal,
                total,
              )}`}
        </span>
        <Select
          labelInValue
          defaultValue={{ value: paginationProps.defaultPageSize || 60 }}
          style={{ width: pageSizeWidth }}
          onChange={pageSizeChange}>
          {pageSizeOption.map((item) => (
            <Option key={item} value={item}>
              {replaceI18nVariables(
                getI18n('general.globalPagination.show:{item}'),
                item,
              )}
            </Option>
          ))}
        </Select>
      </div>
    </div>
  );
};
export default GlobalPagination;
